import configHelper from "common/helpers/config";
import DefaultModule from "Configs/Module/default.json";
import EventService from "Services/EventEmitter";

export default class ModuleStore {
	private static instance: ModuleStore;
	private readonly event = new EventService();
	private _module = DefaultModule;

 constructor() {
		ModuleStore.instance = this;
	}

	public static getInstance() {
		if (!ModuleStore.instance) return new this();
		return ModuleStore.instance;
	}

	public get module() {
		return this._module;
	}

	public set module(module: ModuleStore["_module"]) {
		this._module = module;
	}

	public getModulesFilePath() {
		const environment = process.env["REACT_APP_ENV_NAME"] || "development";
		return `modules/${environment}.json`;
	}

	public async load(): Promise<void> {
		try {
			this.module = await configHelper.fetchJson(this.getModulesFilePath());
			this.event.emit("change", this.module);
		} catch (e) {
			console.error(e);
		}
	}

	public onChange(callback: (module: ModuleStore["_module"]) => void) {
		this.event.on("change", callback);
		return () => {
			this.event.off("change", callback);
		};
	}
}
